import Loader from "./Loader";
import StatPanel from "./StatPanel";
import Stack from "@mui/material/Stack";
import MainCard from "../Layouts/MainCard";
import { CardTitle } from "../theme/texts";
import { useQuery } from "@tanstack/react-query";
import { getWoWStatistics } from "../../api/user";
import { SpacedRow } from "../../data/style/Style";
import { useAuth } from "../../context/AuthContext";
import useScreenSize from "../../context/ScreenContext";

const WoWPerformance = () => {
  const { user, profile } = useAuth();
  const { mobileDevice } = useScreenSize();
  const { data, isPending } = useQuery({
    queryKey: ["user", user.id, "wow", "statistics"],
    queryFn: ({ signal }) => getWoWStatistics({ signal }),
    staleTime: 30 * 60 * 1000,
  });

  return (
    <MainCard>
      <CardTitle
        subTitle={"Analytics"}
        mainTitle={"Workout of the week performance"}
        isMobile={mobileDevice}
      />
      <Stack gap={1} sx={{ minHeight: "35vh" }}>
        {!isPending ? (
          <>
            <SpacedRow width={"100%"} gap={mobileDevice ? 1 : 3} flex={1}>
              <StatPanel
                count={data.total_points}
                text={"Total"}
                subText={"Workout Points"}
              />
              <StatPanel
                count={data.top_finishes}
                text={"Top-10"}
                subText={"Finishes"}
              />
              <StatPanel
                count={profile.wow_place}
                text={"Current"}
                subText={"Workout Place"}
              />
            </SpacedRow>
            <SpacedRow width={"100%"} gap={mobileDevice ? 1 : 3} flex={1}>
              <StatPanel
                count={data.avg_points}
                text={"Points"}
                subText={"Per workout"}
              />
              <StatPanel
                count={data.best_place}
                text={"Highest"}
                subText={"Place"}
              />
              <StatPanel
                count={data.avg_place}
                text={"Average"}
                subText={"Place"}
              />
            </SpacedRow>
          </>
        ) : (
          <Loader height={"100%"} />
        )}
      </Stack>
    </MainCard>
  );
};

export default WoWPerformance;
